import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { candidates, STAGES } from '../data/hrData';
import Table from './ui/Table';
import Badge from './ui/Badge';
import Avatar from './ui/Avatar';
import Select from './ui/Select';
import Modal from './ui/Modal';
import CandidateDetail from './CandidateDetail';
import { Star as _lr_Star } from 'lucide-react';

const Star = _lr_Star || (() => null);
const stageBadge = { Applied: 'default', Screening: 'info', Shortlisted: 'warning', Interview: 'warning', Offer: 'success' };

export function CandidateList() {
  const [stageFilter, setStageFilter] = useState('');
  const [deptFilter, setDeptFilter] = useState('');
  const [selected, setSelected] = useState(null);

  const depts = [...new Set(candidates.map(c => c.department))];
  const filtered = candidates.filter(c =>
    (!stageFilter || c.stage === stageFilter) &&
    (!deptFilter || c.department === deptFilter)
  );

  const columns = [
    { key: 'name', label: 'Candidate', render: (_, row) => (
      <div className="flex items-center gap-2">
        <Avatar src={row.avatar} name={row.name} size="sm" />
        <div>
          <p className="font-medium text-gray-900 text-sm">{row.name}</p>
          <p className="text-xs text-gray-500">{row.email}</p>
        </div>
      </div>
    )},
    { key: 'role', label: 'Role', render: (v) => <span className="text-sm text-gray-700">{v}</span> },
    { key: 'stage', label: 'Stage', render: (v) => <Badge variant={stageBadge[v] || 'default'}>{v}</Badge> },
    { key: 'score', label: 'AI Score', render: (v) => (
      <div className="flex items-center gap-1">
        <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-purple-500 rounded-full" style={{ width: `${v}%` }} />
        </div>
        <span className="text-xs font-bold text-purple-600">{v}%</span>
      </div>
    )},
    { key: 'rating', label: 'Rating', render: (v) => (
      <div className="flex gap-0.5">{[1,2,3,4,5].map(s => <Star key={s} size={12} className={s <= v ? 'text-amber-400 fill-amber-400' : 'text-gray-200'} />)}</div>
    )},
    { key: 'source', label: 'Source' },
    { key: 'appliedDate', label: 'Applied' },
  ];

  return (
    <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }} className="space-y-4">
      <div className="flex gap-3 flex-wrap">
        <div className="w-44"><Select options={['', ...STAGES].map(s => ({ value: s, label: s || 'All Stages' }))} value={stageFilter} onChange={setStageFilter} placeholder="All Stages" /></div>
        <div className="w-44"><Select options={['', ...depts].map(d => ({ value: d, label: d || 'All Depts' }))} value={deptFilter} onChange={setDeptFilter} placeholder="All Departments" /></div>
      </div>
      <Table columns={columns} data={filtered} onRowClick={setSelected} />
      <Modal open={!!selected} onClose={() => setSelected(null)} title="Candidate Profile" className="max-w-2xl">
        {selected && <CandidateDetail candidate={selected} onClose={() => setSelected(null)} />}
      </Modal>
    </motion.div>
  );
}

export default CandidateList;